/**
 * Display a notification
 *
 * TODO: Change this to use a notification library
 *
 * @param {(string|Promise)} message Notification message
 * @param {string} type Notification type (info, success, warning, error)
 */

const addNotification = (message, type, silent = false) => {
  if (message instanceof Promise) {
    message.then((message) => {
      addNotification(message, type, silent);
    });

    return;
  }

  if (silent) {
    // fail silently
    console.log(message);
  } else {
    alert(message);
  }
};

export { addNotification };
